import whatInput from "what-input";
import lazySizes from "lazysizes";
// import Flickity from 'flickity';
// import apiFetch from '@wordpress/api-fetch';
// import Cookies from 'js-cookie';
// var jQueryBridget = require('jquery-bridget');
// Flickity.setJQuery( $ );
// jQueryBridget( 'flickity', Flickity, $ );

lazySizes.cfg.expand = 300;
lazySizes.cfg.loadHidden = false;

(function ($, window) {
  $(function () {
    $.fn.resizeselect = function (settings) {
      return this.each(function () {
        $(this)
          .on("change", function () {
            let $this = $(this);
            let val = $this.val();
            let $test = $this
              .clone()
              .removeAttr("style")
              .removeClass("resizeselect");
            $test.find('option:not([value="' + val + '"])').remove();
            $test.appendTo($this.parent());
            let width = $test.outerWidth();
            $test.remove();
            $this.outerWidth(width);
          })
          .trigger("change");
      });
    };
    $("select.resizeselect").resizeselect();
  });
})(jQuery, window);

// ;(function($) {
//   var Tab = function(tabs_cont, options) {
//     var _this = this;
//     _this.args = $.extend( {
//       class_nav: 'tabs_nav',
//       class_nav_item: 'tabs_i'
//     }, options );
//     _this.tabs_cont = tabs_cont;
//     _this.panels = _this.tabs_cont.find('.js-tabs-section');
//     if(!_this.panels.length) return;
//     _this.tabs_items = $();
//     _this.setNav();
//     _this.tabs_links = _this.tabs_items.find('button');
//     _this.last_item = _this.tabs_items.last(),
//     _this.first_item = _this.tabs_items.first(),
//     _this.last_link = _this.last_item.find('button'),
//     _this.first_link = _this.first_item.find('button');

//     _this.init();
//   };

//   Tab.prototype = {
//     setNav: function () {
//       var _this = this;
//       var tab_nav = $('<ul></ul>');
//       tab_nav.addClass('js-tabs-nav').addClass(_this.args.class_nav);
//       _this.panels.each(function(idx, el) {
//         var panel_title = $(el).find('.js-tabs-title');
//         var nav_item = $('<li></li>');
//         nav_item.addClass(_this.args.class_nav_item).html('<button data-panel="'+el.getAttribute('id')+'" type="button">'+panel_title.html()+'</button>');
//         tab_nav.append(nav_item);
//         panel_title.addClass('srOnly');
//         _this.tabs_items = _this.tabs_items.add(nav_item);
//       });
//       _this.tabs_cont.prepend(tab_nav);
//     },

//     init: function () {
//       var _this = this;

//       //Attributs tablist
//       _this.tabs_cont.attr('role',"tablist");

//       //Attributs items
//       _this.tabs_items.attr('role',"presentation");

//       //Attributs liens
//       _this.tabs_links.each(function(idx, el) {
//         el.setAttribute('role',"tab");
//         var idPanel = el.getAttribute("data-panel");
//         if ( typeof idPanel !== "undefined" && idPanel !== "" ) {
//           el.setAttribute('aria-controls',idPanel);
//           el.setAttribute('id','label-'+idPanel);
//           el.setAttribute('tabindex',-1);
//           el.setAttribute('aria-selected',"false");
//         }
//         // el.removeAttribute('data-panel');
//       });

//       //Attributs panels
//       _this.panels.each(function(idx, el) {
//         var id = el.getAttribute("id");
//         el.setAttribute('role',"tabpanel");
//         el.setAttribute('aria-hidden',"true");
//         el.setAttribute('aria-labelledby','label-'+id);
//       });

//       //Events
//       _this.tabs_links.on('click', function(event) {
//         _this.clickOnTab(this,event);
//       });
//       _this.tabs_cont.on('keydown', function(event) {
//         _this.keyOnTab(event);
//       });

//       //Class init
//       _this.tabs_cont.addClass('js-tabs-init');

//       // on sélectione le panel actif (ou le premier)
//       var panel_index_to_select = 0;
//       _this.panels.each(function(idx, el) {
//         if($(el).hasClass('to-open')) {
//           panel_index_to_select = idx;
//           // $(el).removeClass('to-open');
//         }
//       });
//       if(panel_index_to_select !== false) {
//         _this.tabs_links.eq(panel_index_to_select).trigger('click');
//       }
//     },

//     resetAttr: function () {
//       var _this = this;

//       _this.tabs_links.attr('tabindex',"-1");
//       _this.tabs_links.attr('aria-selected',"false");
//       _this.panels.attr('aria-hidden','true');
//     },

//     clickOnTab: function (link,event) {
//       var _this = this;
//       var target_id = link.getAttribute("aria-controls");
//       var tab_linked = $("#"+target_id);
//       if(link.getAttribute('aria-selected') == 'true' || !tab_linked.length) return;
//       _this.resetAttr();
//       link.setAttribute('aria-selected',"true");
//       link.setAttribute('tabindex',0);
//       tab_linked.removeAttr('aria-hidden');
//       if(event) {
//         event.preventDefault();
//       }
//       _this.tabs_cont.trigger( "tabs:change", [ _this, event.hasOwnProperty('originalEvent'), link, tab_linked.get(0) ] );
//     },

//     keyOnTab: function (event) {
//       var _this = this;

//       if (!event.ctrlKey) {
//         var action = false;
//         if ( event.keyCode == 37 || event.keyCode == 38 ) {
//           // strike up or left in the tab
//           action = _this.prev();
//         } else if ( event.keyCode == 40 || event.keyCode == 39 ) {
//           // strike down or right in the tab
//           action = _this.next();
//         } else if ( event.keyCode == 36 ) {
//           // activate first tab
//           action = _this.goToFirst();
//         } else if ( event.keyCode == 35 ) {
//           // activate last tab
//           action = _this.goToLast();
//         }

//         if (action && event) {
//           event.preventDefault();
//         }
//       }
//     },

//     getActiveItem: function () {
//       var _this = this;
//       var activated = false;
//       _this.tabs_links.each(function(idx, el) {
//         if(!activated && el.hasAttribute('aria-selected') && el.getAttribute('aria-selected') == 'true') activated = el.parentNode;
//       });
//       return activated;
//     },

//     prev: function (noFocus) {
//       var _this = this;

//       var activated = _this.getActiveItem();
//       var linkToClick = false;
//       if (activated) {
//         if ( activated === _this.first_item.get(0) ) {
//           linkToClick = _this.last_link.get(0);
//         } else {
//           linkToClick = activated.previousElementSibling.children[0];
//         }
//       }
//       if ( linkToClick ) {
//         $(linkToClick).trigger('click');
//         if ( !noFocus ) {
//           $(linkToClick).focus();
//         }
//       }
//       return linkToClick;
//     },

//     next: function (noFocus) {
//       var _this = this;

//       var activated = _this.getActiveItem();
//       var linkToClick = false;
//       if (activated) {
//         if ( activated === _this.last_item.get(0) ) {
//           linkToClick = _this.first_link.get(0);
//         } else {
//           linkToClick = activated.nextElementSibling.children[0];
//         }
//       }
//       if ( linkToClick ) {
//         $(linkToClick).trigger('click');
//         if ( !noFocus ) {
//           $(linkToClick).focus();
//         }
//       }
//       return linkToClick;
//     },

//     goTo: function (idx,noFocus) {
//       var _this = this;
//       var $linkToClick = _this.tabs_items.eq(idx).find('button');
//       $linkToClick.trigger('click');
//       if ( !noFocus ) {
//         $linkToClick.focus();
//       }
//       return $linkToClick.get(0);
//     },

//     goToFirst: function () {
//       var _this = this;
//       return _this.goTo(0);
//     },

//     goToLast: function () {
//       var _this = this;
//       return _this.goTo(_this.tabs_links.length - 1);
//     },

//     destroy: function () {
//       var _this = this;
//       _this.tabs_cont.find('.js-tabs-title').removeClass('srOnly');
//       _this.tabs_cont.find('.js-tabs-nav').remove();
//       _this.tabs_cont.removeAttr('role');
//       _this.tabs_items.removeAttr('role');
//       _this.tabs_links.removeAttr('role').removeAttr('aria-controls').removeAttr('id').removeAttr('tabindex').removeAttr('aria-selected');
//       _this.panels.removeAttr('role').removeAttr('aria-hidden').removeAttr('aria-labelledby');
//       _this.tabs_cont.removeClass('js-tabs-init');
//       _this.tabs_cont.off('keydown');
//     },
//   }

//   $.fn.tabs = function(options) {
//     var settings = $.extend({
//       class_nav: 'tabs_nav',
//       class_nav_item: 'tabs_i'
//     }, options );
//     var tabs = [];
//     if(this.length) {
//       this.each(function(idx, el) {
//         tabs.push(new Tab($(el), settings));
//       });
//     }
//     return tabs;
//   };
// })(jQuery);

(function ($) {
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Variables
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var w = window,
    d = document,
    $window = $(w),
    $html = $("html"),
    $body = $("body"),
    $header = $("#header"),
    $headerHeightEl = $(".js-header-height"),
    $nav = $("#nav"),
    $main = $("#main"),
    $stickyBars = $main.find(".stickyBar"),
    headerH,
    windowH,
    windowW,
    scrollT,
    scrollUp = false,
    scrollDiff = 0,
    $adminBar = $("#wpadminbar"),
    has_adminBar = $body.hasClass("admin-bar"),
    adminBar_h = 0,
    serveur_test = d.location.hostname == "localhost",
    is_requeting = false,
    is_menu_mobile = false,
    $triggerMobile = $("#menuTrigger"),
    sauvScroll = 0,
    vhCssVar = false;

  $html.addClass("is-js-init");

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Dimensions
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function update_dimensions() {
    windowH = window.innerHeight;
    windowW = $window.width();
    headerH = $headerHeightEl.length ? $headerHeightEl.outerHeight() : 0;
    var old_is_menu_mobile = is_menu_mobile;
    is_menu_mobile = $triggerMobile.is(":visible");
    if (old_is_menu_mobile != is_menu_mobile) {
      menu_mobile_change(old_is_menu_mobile, is_menu_mobile);
    }
    update_adminbar();
    update_scroll();
  }
  update_dimensions();

  function update_scroll() {
    if ($window.scrollTop() < scrollT) {
      scrollUp = true;
    } else {
      scrollUp = false;
    }
    scrollDiff = $window.scrollTop() - scrollT;
    scrollT = $window.scrollTop();
  }

  function update_adminbar() {
    adminBar_h =
      parseInt($html.css("margin-top")) + parseInt($body.css("margin-top"));
  }

  function menu_mobile_change(o, n) {
    remove_focus_trap_aria_hidden();
    if (!o && n) {
      accs_build();
    } else if (o && !n) {
      accs_mobile_reset();
    }
  }

  function setCssVarVH() {
    if (!vhCssVar || Math.abs(vhCssVar - windowH) > 250) {
      vhCssVar = windowH;
      document.documentElement.style.setProperty("--vh", windowH + "px");
    }
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Helper functions
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // Récupère les variables d'une url
  function getQueryVariables(url) {
    var query = url.split("?");
    var vars = (query.length > 1 ? query[1] : "").split("&");
    var returnVars = {};
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      returnVars[pair[0]] = pair[1] ? pair[1] : null;
    }
    return returnVars;
  }

  //Debounce
  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  //Load js async
  function async(script, callback) {
    var s = document.createElement("script"),
      head = document.getElementsByTagName("head")[0];
    s.type = "text/javascript";
    s.async = true;
    s.defer = true;
    s.src = script;
    if (typeof callback == "function") {
      s.addEventListener(
        "load",
        function (e) {
          callback.call();
        },
        false
      );
    }
    head.appendChild(s);
  }

  //Load css
  function loadCSS(href, callback, media) {
    var doc = w.document;
    var ss = doc.createElement("link");
    var ref;
    var refs = (doc.body || doc.getElementsByTagName("head")[0]).childNodes;
    ref = refs[refs.length - 1];
    var sheets = doc.styleSheets;
    ss.rel = "stylesheet";
    ss.href = href;
    ss.media = "only x";
    ref.parentNode.insertBefore(ss, ref.nextSibling);
    var onloadcssdefined = function (cb) {
      var resolvedHref = ss.href;
      var i = sheets.length;
      while (i--) {
        if (sheets[i].href === resolvedHref) {
          return cb();
        }
      }
      setTimeout(function () {
        onloadcssdefined(cb);
      });
    };
    function loadCB() {
      if (ss.addEventListener) {
        ss.removeEventListener("load", loadCB);
      }
      ss.media = media || "all";
      if (typeof callback == "function") {
        callback();
      }
    }
    if (ss.addEventListener) {
      ss.addEventListener("load", loadCB);
    }
    ss.onloadcssdefined = onloadcssdefined;
    onloadcssdefined(loadCB);
  }

  //pad number
  function pad(number) {
    if (number < 10) {
      return "0" + number;
    }
    return number;
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Scroll jusqu'a un element
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function scrollToEl($el, marge) {
    var offsetEl = 0;
    if (marge) {
      offsetEl -= marge;
    }
    if ($el.length) {
      offsetEl += $el.offset().top - adminBar_h;
      offsetEl -= 36;
      // var elMargin = parseInt($el.css('marginTop'));
      // var elPadding = parseInt($el.css('paddingTop'));
      // if(!elPadding && elMargin) {
      //   offsetEl -= elMargin;
      // } else if(!elPadding) {
      //   elMargin = parseInt($el.prev().css('marginBottom'));
      //   elPadding = parseInt($el.prev().css('paddingBottom'));
      //   if(elPadding) {
      //     offsetEl -= elPadding;
      //   } else if(elMargin) {
      //     offsetEl -= elMargin;
      //   }
      // }
    }
    offsetEl -= headerH;
    scrollToOffset(offsetEl);
  }

  function scrollToOffset(offsetEl) {
    $("html, body").animate(
      {
        scrollTop: offsetEl,
      },
      300
    );
  }

  function scroller_init($cont) {
    $cont = $cont && $cont.length ? $cont : $body;
    var $directElToScroll = $cont.find(".js-scroll-to-me").first();
    if ($directElToScroll.length) scrollToEl($directElToScroll);

    $cont.find('a.js-scroller[href^="#"]').on("click", function (event) {
      if (whatInput.ask() === "keyboard") return;
      var $this = $(this);
      var $target = $($this.attr("href"));
      if ($target.length && $this.attr("data-scroll-parent")) {
        $target = $target.closest($this.attr("data-scroll-parent"));
      }
      if ($target.length) {
        event.preventDefault();
        scrollToEl($target);
      }
    });
  }
  scroller_init();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Supports
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function test_history() {
    var ua = navigator.userAgent;
    if (
      (ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) &&
      ua.indexOf("Mobile Safari") !== -1 &&
      ua.indexOf("Chrome") === -1 &&
      ua.indexOf("Windows Phone") === -1 &&
      location.protocol !== "file:"
    ) {
      return false;
    }
    // if(ua.match(/((iPod|iPhone|iPad).+\bOS\s+[1-4]|WebApps\/.+CFNetwork)/)) {
    // 	return false;
    // }
    return (
      window.history &&
      "pushState" in window.history &&
      "replaceState" in window.history
    );
  }

  var transformProp;
  (function () {
    var style = document.createElement("a").style;
    var prop;
    if (style[(prop = "webkitTransform")] !== undefined) {
      transformProp = prop;
    }
    if (style[(prop = "msTransform")] !== undefined) {
      transformProp = prop;
    }
    if (style[(prop = "transform")] !== undefined) {
      transformProp = prop;
    }
  })();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Focus trap
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var $lastFocusedElement = false;
  var is_focus_traped = false;

  function set_focus_trap($cont) {
    if (!$cont || !$cont.length) return;
    $lastFocusedElement = $(document.activeElement);
    update_content_focus_trap($cont);
    set_focus_trap_aria_hidden($cont);
    is_focus_traped = true;
  }

  function update_content_focus_trap($cont) {
    if (!$cont || !$cont.length) return;
    var $focusableElements = $cont
      .find(
        "a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])"
      )
      .not('[tabindex="-1"]');
    var $firstTabStop = $focusableElements.first();
    var $lastTabStop = $focusableElements.last();
    $firstTabStop.focus();
    $cont.off("keydown").on("keydown", function (event) {
      if (event.keyCode === 9) {
        //Tab
        if (event.shiftKey) {
          //Shift + Tab
          if (document.activeElement === $firstTabStop.get(0)) {
            event.preventDefault();
            $lastTabStop.focus();
          }
        } else {
          //just Tab
          if (document.activeElement === $lastTabStop.get(0)) {
            event.preventDefault();
            $firstTabStop.focus();
          }
        }
      }
    });
  }

  function remove_focus_trap($cont) {
    if (!$cont || !$cont.length) return;
    $cont.off("keydown");
    remove_focus_trap_aria_hidden();
    if ($lastFocusedElement && $lastFocusedElement.length) {
      $lastFocusedElement.focus();
    }
    is_focus_traped = false;
  }

  function set_focus_trap_aria_hidden($el) {
    $el
      .siblings(":not(script):not(link):not([aria-hidden])")
      .attr("aria-hidden", "true")
      .addClass("is-hidden-by-focus-trap");
    // if($el.is('.nav')) {
    //   $el.closest('.header').siblings(':not(script):not(link):not([aria-hidden])').not('.toolbar').attr('aria-hidden', 'true').addClass('is-hidden-by-focus-trap');
    //   $('#toolbar').find('.toolbar_navi:not(.toolbar_navi-navmobile)').attr('aria-hidden', 'true').addClass('is-hidden-by-focus-trap');
    // }
  }

  function remove_focus_trap_aria_hidden() {
    $body
      .find(".is-hidden-by-focus-trap")
      .removeAttr("aria-hidden")
      .removeClass("is-hidden-by-focus-trap");
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Menu
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // var $nav_links = $header.find('.nav_i > a');
  // var $nav_items = $header.find('.nav_i');

  // menu_set_a11y();
  // $nav_links.on('click', trigger_nav_link);

  // function trigger_nav_link(event) {
  //   var $this = $(this);
  //   var $link_item = $this.closest('.nav_i');
  //   var $sub_menu = $link_item.find('.nav_sub');
  //   if(!$sub_menu.length) {
  //     closeSubMenu(true);
  //     return;
  //   }
  //   event.preventDefault();
  //   if($link_item.hasClass('is-open')) {
  //     $link_item.removeClass('is-open');
  //     $html.removeClass('has-subnavOpen');
  //     // if(!is_menu_mobile) {
  //     //   window.scrollTo(0, sauvScroll);
  //     // }
  //     // remove_focus_trap($sub_menu);
  //   } else {
  //     if(!$html.hasClass('has-subnavOpen')) {
  //       // if(!is_menu_mobile) {
  //       //   sauvScroll = scrollT;
  //       // }
  //     } else {
  //       $nav_items.removeClass('is-open');
  //     }
  //     $link_item.addClass('is-open');
  //     $html.addClass('has-subnavOpen');
  //     // set_focus_trap($sub_menu);
  //     $sub_menu.find('input').focus();
  //   }
  //   menu_update_a11y();
  // }

  // function closeSubMenu(resetTrap) {
  //   if($html.hasClass('has-subnavOpen')) {
  //     // if(resetTrap) {
  //     //   remove_focus_trap($nav_items.filter('.is-open').find('.nav_sub'));
  //     // }
  //     $html.removeClass('has-subnavOpen');
  //     $nav_items.removeClass('is-open');
  //     // if(!is_menu_mobile) {
  //     //   window.scrollTo(0, sauvScroll);
  //     // }
  //     menu_update_a11y();
  //   }
  // }

  // function menu_set_a11y() {
  //   $nav.find('.nav_wrapper').attr({
  //     'role': 'menubar',
  //     'aria-label': 'Menu principal'
  //   });
  //   $header.find('.header_nav-2 .nav_wrapper').attr({
  //     'role': 'menubar',
  //     'aria-label': 'Menu secondaire'
  //   });
  //   $nav_links.each(function(idx, el) {
  //     var $el = $(el);
  //     $el.attr('role', 'menuitem').filter(':not(:last-child)').attr({
  //       'aria-haspopup': 'true',
  //       'aria-expanded': 'false',
  //       'aria-controls': 'menu-item-'+(idx+1)
  //     }).next('.nav_sub').attr({
  //       'aria-hidden': 'true',
  //       'id': 'menu-item-'+(idx+1)
  //     }).find('ul').attr('role', 'menu').find('li').attr('role', 'none').children('a').attr('role', 'menuitem');
  //   });
  //   $nav_items.attr('role', 'none');
  // }

  // function menu_update_a11y() {
  //   $nav_links.filter(':not(:last-child)').closest('.nav_i').each(function(index, el) {
  //     var $el = $(el);
  //     if($(el).hasClass('is-open')) {
  //       $el.children('a').attr('aria-expanded', 'true').next('.nav_sub').attr('aria-hidden', 'false');
  //     } else {
  //       $el.children('a').attr('aria-expanded', 'false').next('.nav_sub').attr('aria-hidden', 'true');
  //     }
  //   });
  // }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Menu mobile
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var idMenuMobileTimeOut = false;
  $triggerMobile.on("click", function (event) {
    event.preventDefault();
    menu_mobile_toggle();
  });

  function menu_mobile_toggle() {
    if ($html.hasClass("has-menuMobileOpen")) {
      menu_mobile_close();
    } else {
      menu_mobile_open();
    }
  }

  function menu_mobile_open() {
    if (!$html.hasClass("is-scrollBlockedMobile")) {
      sauvScroll = scrollT;
      w.scrollTo(0, 0);
      idMenuMobileTimeOut = w.setTimeout(function () {
        $html.addClass("is-scrollBlockedMobile");
      }, 300);
    }
    $html.addClass("has-menuMobileOpen");
  }

  function menu_mobile_close() {
    if (idMenuMobileTimeOut) w.clearTimeout(idMenuMobileTimeOut);
    $html.removeClass("is-scrollBlockedMobile");
    // closeSubMenu();
    w.scrollTo(0, sauvScroll);
    w.setTimeout(function () {
      $html.removeClass("has-menuMobileOpen");
    }, 50);
  }

  $header
    .find(".nav_i > a:not(.btn):not(:last-child)")
    .on("click", function (event) {
      if (!is_menu_mobile) return;
      event.preventDefault();
      $(this).closest(".nav_i").toggleClass("is-submenuMobileOpen");
    });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Menu espace adherent mobile
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  $body.find(".esNav_mobileTrigger").on("click", function (event) {
    event.preventDefault();
    $body.find(".esNav_list").toggleClass("is-open");
  });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Accordéons
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function accs_init($cont) {
    $cont = $cont && $cont.length ? $cont : $main;
    $cont.find(".acc:not(.js-acc)").addClass("js-acc");
    // $cont
    //   .find('.matiere_section:not(.js-acc)')
    //   .addClass('js-acc')
    //   .addClass('js-acc-mobile');
    accs_build($cont);
  }
  accs_init();

  function accs_build($cont) {
    $cont = $cont && $cont.length ? $cont : $main;
    $cont.find(".js-acc:not(.is-init)").each(function (idx, el) {
      acc_build(el);
    });
  }

  function acc_build(el, idAcc) {
    var $wrapper = $(el);
    var $head = $wrapper.children(":nth-last-child(2)");
    var $cont = $wrapper.children(":nth-child(2)");
    idAcc =
      idAcc ||
      Math.floor(Math.random() * (1000 + 1)) +
        1000 +
        "" +
        (Math.floor(Math.random() * (1000 + 1)) + 1000) +
        "" +
        (Math.floor(Math.random() * (1000 + 1)) + 1000) +
        "";
    if (
      !$head.length ||
      !$cont.length ||
      (!is_menu_mobile && $wrapper.hasClass("js-acc-mobile"))
    )
      return;
    $head
      .addClass("js-acc-head")
      .wrapInner(
        '<button type="button" aria-expanded="false" aria-controls="acc-id-' +
          idAcc +
          '" id="acc-title-id-' +
          idAcc +
          '"></button>'
      );
    $wrapper.addClass("is-init").addClass("is-closed");
    $cont
      .addClass("js-acc-content")
      .hide()
      .attr("id", "acc-id-" + idAcc)
      .attr("aria-labelledby", "acc-title-id-" + idAcc)
      .attr("aria-hidden", "true");
    $head.on("click", "button", function (event) {
      event.preventDefault();
      $cont.slideToggle(400);
      if ($wrapper.hasClass("is-closed")) {
        $wrapper.removeClass("is-closed");
        $head.find("[aria-expanded]").attr("aria-expanded", "true");
        $cont.attr("aria-hidden", "false");
      } else {
        $wrapper.addClass("is-closed");
        $head.find("[aria-expanded]").attr("aria-expanded", "false");
        $cont.attr("aria-hidden", "true");
      }
    });
  }

  function accs_mobile_reset($cont) {
    $cont = $cont && $cont.length ? $cont : $main;
    if (is_menu_mobile) return;
    $cont.find(".js-acc-mobile.is-init").each(function (idx, el) {
      acc_reset(el);
    });
  }

  function acc_reset(el) {
    var $wrapper = $(el);
    var $head = $wrapper.children(":nth-last-child(2)");
    var $cont = $wrapper.children(":nth-child(2)");
    $wrapper.removeClass("is-init").removeClass("is-closed");
    $head
      .removeClass("js-acc-head")
      .off("click", "button")
      .find("button")
      .contents()
      .unwrap();
    $cont
      .removeClass("js-acc-content")
      .removeAttr("id")
      .removeAttr("style")
      .removeAttr("aria-labelledby")
      .removeAttr("aria-hidden");
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Scroll et ouverture accordéon initial
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  if (location.hash) {
    var locationHash = location.hash.replace("#", "");
    var $scrollTarget = $main.find('[data-target-id="' + locationHash + '"]');
    if (!$("#" + locationHash).length && $scrollTarget.length) {
      scrollToEl($scrollTarget);
      if ($scrollTarget.is(".js-acc.is-init.is-closed")) {
        $scrollTarget.find(".js-acc-head button").trigger("click");
      }
    }
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Sticky bar
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // var $stickyBarActive;
  // var $barContainer;
  //
  // function sticky_init($cont) {
  //   $cont = $cont && $cont.length ? $cont : $main;
  //   $stickyBars = $cont.find('.stickyBar');
  //   $stickyBarActive = false;
  //   $barContainer = $cont.find('[data-fixed-container]');
  //   if(!$barContainer.length) {
  //     $barContainer = $cont.find('.page');
  //   }
  // }
  // sticky_init();
  //
  // function sticky_update_all() {
  //   if(is_menu_mobile || !$stickyBars.length) return;
  //   $stickyBars.each(function(idx, el) {
  //     sticky_update(el);
  //   });
  // }
  //
  // function sticky_update(bar) {
  //   if(is_menu_mobile) return;
  //   var $bar = $(bar);
  //   var $barInner = $bar.find('.stickyBar_inner');
  //   if(
  //     (
  //       bar.getBoundingClientRect().top <= adminBar_h + 0
  //       || $bar.hasClass('is-fixed') && bar.getBoundingClientRect().top <= $barInner.get(0).getBoundingClientRect().top
  //     ) && (
  //       !$barContainer.length
  //       || $barContainer.get(0).getBoundingClientRect().top + $barContainer.innerHeight() >= adminBar_h + 0 + $bar.innerHeight()
  //     )
  //   ) {
  //     if(!$bar.hasClass('is-fixed')) {
  //       $bar.addClass('is-fixed');
  //       $stickyBarActive = $bar;
  //     }
  //   } else {
  //     if($bar.hasClass('is-fixed')) {
  //       $bar.removeClass('is-fixed');
  //       $stickyBarActive = false;
  //     }
  //   }
  // }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Menu qui se masque
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function scroll_classes_header() {
    // if(is_menu_mobile) {
    //   return;
    // }
    if (scrollT > 5) {
      $html.addClass("is-nav-small");
    } else {
      $html.removeClass("is-nav-small");
    }
  }
  scroll_classes_header();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Grille
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // function grid_init($cont,$grids) {
  //   $cont = $cont && $cont.length ? $cont : $main;
  //   $grids = $grids && $grids.length ? $grids : $cont.find('.js-grid');
  //   if(!$grids.length) return;
  //
  //   $grids.each(function(idx, el) {
  //     $(el).addClass('is-init');
  //     var $childs = $(el).children(':not(.is-hide)');
  //     ffgrid({
  //       cont: el,
  //       item: $childs.toArray(),
  //       cols: el.hasAttribute('data-nb-cols') ? parseInt(el.getAttribute('data-nb-cols')) : false,
  //       gutterW: parseFloat($childs.first().css('margin-right')),
  //       gutterH: parseFloat($childs.first().css('margin-bottom')),
  //       variableW: el.hasAttribute('data-variable-width'),
  //     });
  //   });
  // }
  // grid_init();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Modales
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // $body.find('.js-modal').appendTo($body);
  // $body.find('[data-modal]').on('click', function(event) {
  //   event.preventDefault();
  //   var $target = $('#'+$(this).attr('data-modal'));
  //   if($target.length) {
  //     $target.removeClass('is-hide').attr('aria-hidden', 'false');
  //     $html.addClass('has-modal');
  //     set_focus_trap($target);
  //   }
  // });
  // $body.find('.js-modal-close').on('click', function(event) {
  //   event.preventDefault();
  //   modale_close(this);
  // });
  //
  // function modale_close(target) {
  //   if($html.hasClass('has-modal')) {
  //     if(target) {
  //       remove_focus_trap($(target).closest('.js-modal'));
  //       $(target).closest('.js-modal').addClass('is-hide').attr('aria-hidden', 'true');
  //     } else {
  //       remove_focus_trap($body.find('.js-modal:not(.is-hide)'));
  //       $body.find('.js-modal:not(.is-hide)').addClass('is-hide').attr('aria-hidden', 'true');
  //     }
  //     $html.removeClass('has-modal');
  //   }
  // }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Select2
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // var select2_is_ready = false;
  // var select2_js_is_ready = false;
  // var select2_css_is_ready = false;
  // var select2_js_is_loading = false;
  // var select2_css_is_loading = false;
  //
  // function init_selects() {
  //   var $selects = $body.find('.js-select');
  //   if(is_menu_mobile || !$selects.length) return;
  //   selects_load_select2();
  // }
  // init_selects();
  //
  // function selects_destroy() {
  //   if ($.fn.select2) {
  //     $body.find('.js-select.select2-hidden-accessible').select2('destroy');
  //   }
  // }
  //
  // function selects_load_select2() {
  //   if(select2_is_ready) {
  //     init_select2_on_selects();
  //     return;
  //   }
  //   if(!select2_js_is_loading) {
  //     select2_js_is_loading = true;
  //     async(url.theme+'js/vendor/select2.min.js', select2_js_loaded);
  //   }
  //   if(!select2_css_is_loading) {
  //     select2_css_is_loading = true;
  //     loadCSS(url.theme+'js/vendor/select2.min.css', select2_css_loaded, $('head').find('link[rel="stylesheet"]').get(0));
  //   }
  // }
  //
  // function select2_js_loaded() {
  //   select2_js_is_ready = true;
  //   check_select2_is_ready();
  // }
  //
  // function select2_css_loaded() {
  //   select2_css_is_ready = true;
  //   check_select2_is_ready();
  // }
  //
  // function check_select2_is_ready() {
  //   if(!select2_is_ready && select2_js_is_ready && select2_css_is_ready) {
  //     select2_is_ready = true;
  //     init_select2_on_selects();
  //   }
  //   return select2_is_ready;
  // }
  //
  // function init_select2_on_selects() {
  //   $body.find('.js-select').each(function(index, el) {
  //     $(el).select2({
  //       dropdownAutoWidth: false,
  //       width: 'resolve',
  //       dropdownParent: !el.hasAttribute('data-no-append') ? $(el).parent() : false,
  //       minimumResultsForSearch: Infinity,
  //       theme: el.hasAttribute('data-theme') ? el.getAttribute('data-theme') : 'scene',
  //       dropdownPosition: 'below'
  //       // placeholder
  //     });
  //     $(el).on('select2:open',function(e){
  //       setTimeout(function(){
  //         $(el).resize();
  //       },10);
  //     });
  //   });
  // }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Datepicker (http://t1m0n.name/air-datepicker/docs/)
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // var datepicker_is_ready = false;
  // var datepicker_js_is_ready = false;
  // var datepicker_css_is_ready = false;
  // var datepicker_js_is_loading = false;
  // var datepicker_css_is_loading = false;
  //
  // function init_datepickers() {
  //   var $datepickers = $body.find('.js-datepicker');
  //   if(!$datepickers.length) return;
  //   selects_load_datepicker();
  // }
  // init_datepickers();
  //
  // function selects_load_datepicker() {
  //   if(datepicker_is_ready) {
  //     init_datepicker_on_datepickers();
  //     return;
  //   }
  //   if(!datepicker_js_is_loading) {
  //     datepicker_js_is_loading = true;
  //     async(url.theme+'js/vendor/datepicker.min.js', datepicker_js_loaded);
  //   }
  //   if(!datepicker_css_is_loading) {
  //     datepicker_css_is_loading = true;
  //     loadCSS(url.theme+'js/vendor/datepicker.min.css', datepicker_css_loaded, $('head').find('link[rel="stylesheet"]').get(0));
  //   }
  // }
  //
  // function datepicker_js_loaded() {
  //   datepicker_js_is_ready = true;
  //   check_datepicker_is_ready();
  // }
  //
  // function datepicker_css_loaded() {
  //   datepicker_css_is_ready = true;
  //   check_datepicker_is_ready();
  // }
  //
  // function check_datepicker_is_ready() {
  //   if(!datepicker_is_ready && datepicker_js_is_ready && datepicker_css_is_ready) {
  //     datepicker_is_ready = true;
  //     init_datepicker_on_datepickers();
  //   }
  //   return datepicker_is_ready;
  // }
  //
  // function init_datepicker_on_datepickers() {
  //   $body.find('.js-datepicker').each(function(index, el) {
  //     datepicker_set(el);
  //   });
  // }
  //
  // function datepicker_set(input) {
  //   var $input = $(input);
  //   var $inputAlt = $input.parent().find('input.js-datepicker-alt');
  //   var datepicker = $input.datepicker({
  //     language: { //https://github.com/t1m0n/air-datepicker/tree/master/dist/js/i18n
  //       // days: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'], //pas utilisé
  //       // daysShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'], //pas utilisé
  //       daysMin: str.days_letter,
  //       months: str.months,
  //       monthsShort: str.months_short,
  //       // today: "Aujourd’hui", //pas utilisé
  //       // clear: 'Effacer', //pas utilisé
  //       dateFormat: str.dateformat,
  //       // timeFormat: 'hh:ii', //pas utilisé
  //       firstDay: parseInt(str.first_day_week)
  //     },
  //     showOtherMonths: false,
  //     selectOtherMonths: false,
  //     autoClose: true,
  //     navTitles: {
  //       days: str.datepicker_navtitles,
  //     },
  //     altField: $inputAlt,
  //     altFieldDateFormat: 'yyyy/mm/dd',
  //     minDate: new Date(),
  //     position: 'bottom right',
  //     offset: 0,
  //     range: true,
  //     multipleDatesSeparator: ' - ',
  //     toggleSelected: false,
  //     prevHtml: '<span class="icon-carret_left"></span>',
  //     nextHtml: '<span class="icon-carret_right"></span>',
  //     onShow: function(inst, animationCompleted) {
  //       $input.closest('.calendar').addClass('has-calendar-open');
  //       setTimeout(function(){
  //         datepicker.update('position');
  //       },5);
  //     },
  //     onHide: function(inst, animationCompleted) {
  //       $input.closest('.calendar').removeClass('has-calendar-open');
  //     },
  //     onSelect: function(formattedDate, date, inst) {
  //       if($input.hasClass('is-datapicker-init') && (!date || date.length && date.length >= 1)) {
  //         var $parent = inst && inst.el ? $(inst.el).closest('[data-filters]') : [];
  //         if(date.length && date.length >= 1 && $('#filter-select-type_activite').length && $('#filter-select-type_activite').val() == '-1') {
  //           $('#filter-select-type_activite').val('').trigger('change');
  //         } else if($parent && $parent.length) { //si trigger change précédent ça update déjà
  //           filters_update($parent,'datepicker');
  //         }
  //       }
  //       if(date && date.length && date.length >= 1) {
  //         $input.closest('.calendar').addClass('has-calendar-value');
  //       } else {
  //         $input.closest('.calendar').removeClass('has-calendar-value');
  //       }
  //       if($input.val() && $input.val() != '') {
  //         $input.closest('.calendar').addClass('has-calendar-value');
  //       } else {
  //         $input.closest('.calendar').removeClass('has-calendar-value');
  //       }
  //       var dateDisplay = $input.val();
  //       if ( date.length && date.length >= 2 && ''+date[0].getFullYear()+pad(date[0].getMonth()+1)+pad(date[0].getDate()) == ''+date[1].getFullYear()+pad(date[1].getMonth()+1)+pad(date[1].getDate()) ) {
  //         dateDisplay = dateDisplay.split(' - ')[0];
  //       }
  //       $input.closest('.calendar').find('.calendar_choosen').html(dateDisplay);
  //     },
  //     onRenderCell: function(date, cellType) {
  //       if (cellType == 'day') {
  //         var intDate = date ? parseInt(''+date.getFullYear()+pad(date.getMonth()+1)+pad(date.getDate())) : false;
  //         if(intDate && dates_activites.indexOf(intDate) !== -1) {
  //           return {
  //             // html: '',
  //             classes: 'has-activites',
  //             // disabled: true
  //           }
  //         }
  //       }
  //     }
  //   }).data('datepicker');
  //
  //   $input.parent().find('.js-datepicker-reset').on('click', function(event) {
  //     event.preventDefault();
  //     datepicker.clear();
  //   });
  //
  //   if($inputAlt.val() && $inputAlt.val() != '') {
  //     var arrayDates = $inputAlt.val().replace(/[^0-9-]/g, "").split('-');
  //     arrayDates = arrayDates.map(function(v) {
  //       if(v.length == 8) {
  //         return [parseInt(v.substring(0,4)),parseInt(v.substring(4,6)),parseInt(v.substring(6,8))];
  //       } else {
  //         return false;
  //       }
  //     }).filter(function(v) {
  //       return v && v.length == 3 && v[2] <= 31 && v[2] >= 1 && v[1] <= 12 && v[1] >= 1 && v[0] <= 3000 && v[0] >= 1900;
  //     }).map(function(v) {
  //       return new Date(v[0],v[1] - 1,v[2],23,59,59,999);
  //     }).filter(function(v) {
  //       return v >= new Date();
  //     }).slice(0,2);
  //     if(arrayDates.length) {
  //       datepicker.selectDate(arrayDates);
  //     } else {
  //       $inputAlt.val('');
  //     }
  //   }
  //   $input.addClass('is-datapicker-init');
  // }
  //
  // function datepicker_update_dates($parent,dates) {
  //   var datepicker = $parent.find('.js-datepicker').first().data('datepicker');
  //   if(datepicker)
  //     datepicker.update();
  // }
  //
  // function datepicker_clear_dates($parent) {
  //   var datepicker = $parent.find('.js-datepicker').first().data('datepicker');
  //   if(datepicker)
  //     datepicker.clear();
  // }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Slider
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // $('.slider').each(function(index, el) {
  //   $(el).on('slider:destroy', function(event) {
  //     slider_destroy(this)
  //   }).on('slider:construct', function(event) {
  //     slider_construct(this);
  //   }).trigger('slider:construct').on('focus', '.slider_i a', slider_focus_on_slide);
  // });
  //
  // function slider_construct(el) {
  //   new Flickity(el,{
  //     cellAlign: 'left',
  //     wrapAround: false,
  //     // lazyLoad: 2, //data-flickity-lazyload-srcset & data-flickity-lazyload-src
  //     pageDots: $(el).find('.slider_i').length > 1,
  //     groupCells: false,
  //     contain: true,
  //     adaptiveHeight: false,
  //     setGallerySize: false,
  //     resize: false,
  //     prevNextButtons: false,
  //   });
  // }

  // function slider_destroy(el) {
  //   var flkty = Flickity.data( el );
  //   flkty.destroy();
  // }

  // function slider_focus_on_slide(event) {
  //   var $slide = $(this).closest('.slider_i');
  //   var $slider = $slide.closest('.slider');
  //   if(!$slider.hasClass('flickity-enabled')) return;
  //   var flkty = Flickity.data( $slider.get(0) );
  //   flkty.selectCell($slide.index());
  // }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Plyr
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var plyr_is_ready = false;
  var plyr_js_is_ready = false;
  var plyr_css_is_ready = false;
  var plyr_js_is_loading = false;
  var plyr_css_is_loading = false;
  var $videosIframes = [];
  $main
    .find(".media.is-type-video iframe[src]")
    .wrap('<div class="js-plyr"></div>');

  function init_videos() {
    if (!$videosIframes.length) return;
    video_load_plyr();
  }

  function reinit_videos() {
    $videosIframes = $main.find(".js-plyr");
    init_videos();
  }
  reinit_videos();

  function video_load_plyr() {
    if (plyr_is_ready) {
      init_plyr_on_video();
      return;
    }

    if (!plyr_js_is_loading) {
      plyr_js_is_loading = true;
      async(url.theme + "lib/plyr.min.js", plyr_js_loaded);
    }
    if (!plyr_css_is_loading) {
      plyr_css_is_loading = true;
      loadCSS(url.theme + "lib/plyr.min.css", plyr_css_loaded);
    }
  }

  function plyr_js_loaded() {
    plyr_js_is_ready = true;
    check_plyr_is_ready();
  }

  function plyr_css_loaded() {
    plyr_css_is_ready = true;
    check_plyr_is_ready();
  }

  function check_plyr_is_ready() {
    if (!plyr_is_ready && plyr_js_is_ready && plyr_css_is_ready) {
      plyr_is_ready = true;
      init_plyr_on_video();
    }
    return plyr_is_ready;
  }

  function init_plyr_on_video() {
    // https://github.com/sampotts/plyr
    var players = Plyr.setup("#main .js-plyr", {
      vimeo: {
        controls: false,
      },
      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true,
        container: null,
      },
      controls: [
        "play",
        "progress",
        "current-time",
        "mute",
        "volume",
        "fullscreen",
        "play-large",
      ],
    });
  }

  d.addEventListener("lazybeforeunveil", function (e) {
    var $el = $(e.target);
    if (!$el.is("iframe")) return;
    $el.attr("src", $el.attr("data-src"));
    if ($el.closest(".media.is-type-video").length) {
      $el.wrap('<div class="js-plyr"></div>');
    }
    reinit_videos();
    e.preventDefault();
  });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Forms
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // function form_init($cont) {
  //   $cont = $cont && $cont.length ? $cont : $main;
  //   $cont.find('.form_p input, .form_p select:not(.js-select), .form_p textarea').on('focus', function(event) {
  //     $(this).closest('.form_p').removeClass('is-error');
  //   });
  //   $cont.find('.form_field-float input, .form_field-float textarea').on('blur', function(event) {
  //     if(this.value) $(this).addClass('has-content');
  //     else $(this).removeClass('has-content');
  //   }).trigger('blur');
  //   $cont.find('.form_field-float select').on('change', function(event) {
  //     if(this.value) $(this).addClass('has-content');
  //     else $(this).removeClass('has-content');
  //   }).trigger('change');
  //
  //   $cont.find('[type="checkbox"][data-check-control]').each(function(index, el) {
  //     form_part_change(el);
  //   }).on('click', function(event) {
  //     form_part_change(this);
  //   });
  // }
  // form_init();
  //
  // function form_part_change(checkboxe) {
  //   if(checkboxe.checked) {
  //     form_part_show($('#'+$(checkboxe).attr('data-check-control')));
  //   } else {
  //     form_part_hide($('#'+$(checkboxe).attr('data-check-control')));
  //   }
  // }
  //
  // function form_part_hide($cont) {
  //   $cont.hide();
  //   $cont.find('input, select, textarea').attr('disabled', 'disabled');
  // }
  //
  // function form_part_show($cont) {
  //   $cont.show();
  //   $cont.find('input, select, textarea').removeAttr('disabled');
  // }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Sticky (pageNav)
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var $stickyBars = [];
  function sticky_init($cont) {
    $cont = $cont && $cont.length ? $cont : $main;
    $stickyBars = $cont.find(".js-sticky");
  }
  sticky_init();

  function sticky_update_all() {
    if (is_menu_mobile || !$stickyBars.length) return;
    $stickyBars.each(function (idx, el) {
      sticky_update(el);
    });
  }
  sticky_update_all();

  function sticky_update(el) {
    if (is_menu_mobile) return;
    var $el = $(el);
    var $navMargin = 0;
    var $cont = $el.closest("[data-sticky-container]");
    var isAdherent = $html.hasClass("is-espace-adherent");
    var isActuAdh = $main.find(".page-actu_adh").length > 0;
    var elMarginTop = 0;
    if ($cont.closest(".page-template-archives-fiche").length > 0) {
      elMarginTop = 120;
    } else if (isAdherent && !isActuAdh) {
      elMarginTop = 270;
    }

    var contPaddingBottom = $cont.length
      ? parseInt($cont.css("padding-bottom"))
      : 0;
    var navTop = isActuAdh ? 160 : 0;

    var $parent = $el.parent();
    var upToTop =
      $parent.get(0).getBoundingClientRect().top + navTop - elMarginTop <=
      adminBar_h + 0;
    var upToCont =
      !$cont.length ||
      $cont.get(0).getBoundingClientRect().top + $cont.outerHeight() >=
        adminBar_h + 0 + $el.outerHeight() + contPaddingBottom;

    // Dépassement de la barre de navigation (si plus grande que la fenêtre)
    var barOverflow = Math.max(
      0,
      $el.outerHeight() -
        parseInt($el.css("padding-bottom")) +
        36 -
        (windowH - adminBar_h)
    );

    if (upToTop && upToCont) {
      if (!$el.hasClass("is-sticked")) {
        $el.addClass("is-sticked");
        $el.removeClass("is-sticked-bottom");
        $el.css("width", $parent.outerWidth() + "px");
      }
      // Gestion du dépassement
      if (barOverflow > 0) {
        var barTranslateY = Math.max(
          0,
          Math.min(barOverflow, ($el.data("translateY") || 0) + scrollDiff)
        );

        $el.data("translateY", barTranslateY);
        $el.css("transform", "translateY(" + -barTranslateY + "px)");
      }
    } else {
      if ($el.hasClass("is-sticked")) {
        if (upToCont) {
          $el.removeClass("is-sticked");
          $el.removeClass("is-sticked-bottom");
          $el.removeAttr("style");
          $el.data("translateY", 0);
        } else {
          if (
            barOverflow > 0 &&
            $cont.length &&
            $cont.get(0).getBoundingClientRect().top + $cont.outerHeight() >=
              adminBar_h +
                0 +
                $el.outerHeight() -
                barOverflow +
                contPaddingBottom
          ) {
            // rien
          } else {
            $el.addClass("is-sticked-bottom");
            $el.removeClass("is-sticked");
            $el.removeAttr("style");
            $el.data("translateY", 0);
          }
        }
      }
    }
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Page barre de navigation
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var $pageNav;
  var $pageNavItems;
  var $pageNavTitles;
  var pageNavTitlesIDs = [];

  function page_nav_init($cont) {
    $cont = $cont && $cont.length ? $cont : $main;
    $pageNav = $cont.find(".pageNav");
    $pageNavItems = $pageNav.find("li");
    $pageNavItems.each(function (index) {
      pageNavTitlesIDs.push($(this).find("a").attr("href"));
    });
    $pageNavTitles = $cont.find("h2[id],h3[id]").filter(function (index) {
      return $.inArray("#" + $(this).attr("id"), pageNavTitlesIDs) !== -1;
    });
  }
  page_nav_init();

  function page_nav_update() {
    if (!$pageNav.length || !$pageNavTitles.length) return;
    var $activeTitle = [];
    var $activeItem = false;
    var offset = adminBar_h + headerH;
    $pageNavTitles.each(function (idx, el) {
      var $el = $(el);
      // var elMargin = parseInt($el.css('marginTop'));
      // if(elMargin) {
      //   offset += elMargin;
      // }
      if (
        el.previousElementSibling &&
        el.previousElementSibling.getBoundingClientRect().top +
          el.previousElementSibling.clientHeight <=
          offset
      ) {
        $activeTitle = $el;
      }
    });
    if (!$activeTitle.length) {
      $activeTitle = $pageNavTitles.first();
    }
    $activeItem = $pageNav
      .find('a[href="#' + $activeTitle.attr("id") + '"]')
      .closest("li");
    if ($activeItem.length && !$activeItem.hasClass("is-active")) {
      $pageNavItems.removeClass("is-active");
      $activeItem.addClass("is-active");
    }
  }
  page_nav_update();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Accueil / mission tabs
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // $main.find( '.homeMissions_cont.js-tabs' ).on('tabs:change',function(event) {
  //   var $el = $(this).find('.js-tabs-section:not([aria-hidden="true"]) .flickity-enabled');
  //   var flkty = $el && $el.length ? $el.data('flickity') : false;
  //   // console.log(flkty);
  //   if(flkty) {
  //     $el.flickity('resize');
  //   }
  // });
  // $main.find( '.homeMissions_cont.js-tabs' ).first().tabs({
  //   class_nav: 'homeMissions_nav',
  //   class_nav_item: 'homeMissions_navi'
  // });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Alerte
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // $body.on('click','.js-alert-close',function(event) {
  //   event.preventDefault();
  //   Cookies.set('alisfa-hide-alert', $(this).closest('.alertBanner').attr('id'));
  //   $(this).closest('.alertBanner').remove();
  // });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Pagination
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // var is_pagination_request = false;
  // $body.on('click','.js-pagination',function(event) {
  //   var $btn = $(this);
  //   event.preventDefault();
  //   if(is_pagination_request) return;
  //   is_pagination_request = true;
  //   $.ajax({
  //     url: url.ajax,
  //     type: 'POST',
  //     dataType: 'json',
  //     data: {action: 'get_next_posts', link: $btn.attr('href')}
  //   })
  //   .done(function(data) {
  //     if(data && data.result && data.result != '') {
  //       $btn.closest('.page_content').find('.archivesActus,.archivesReunions').append(data.result);
  //     }
  //     if(data && data.btn && data.btn != '') {
  //       $btn.parent().replaceWith(data.btn);
  //     } else {
  //       $btn.parent().remove();
  //     }
  //     if (test_history()) {
  //       window.history.replaceState({}, '', $btn.attr('href'));
  //     }
  //   })
  //   .fail(function() {
  //     // console.log("error");
  //   })
  //   .always(function() {
  //     is_pagination_request = false;
  //   });
  // });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Slider mobile (accueil)
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // $('.page-template-home .grid3, .page-template-home .grid4').each(function(index, el) {
  //   var $el = $(el);
  //   var flky = $el.flickity({
  //     cellAlign: 'left',
  //     wrapAround: false,
  //     // lazyLoad: 2, //data-flickity-lazyload-srcset & data-flickity-lazyload-src
  //     pageDots: false,
  //     groupCells: false,
  //     contain: true,
  //     setGallerySize: true,
  //     prevNextButtons: false,
  //     watchCSS: true,
  //     on: {
  //       ready: function() {
  //         setSliderHeightToMax(this);
  //       },
  //       resize: function() {
  //         // flkty.slides.forEach(slide => slide.style.height = '');
  //         //
  //         // let heights = flkty.slides.map(slide => slide.offsetHeight),
  //         //     max = Math.math.apply(Math, heights);
  //         //
  //         // flkty.slides.forEach(slide => slide.style.height = max + 'px');
  //         setSliderHeightToMax(this);
  //       }
  //     }
  //   });
  // });

  // function setSliderHeightToMax(slider) {
  //   slider.cells.forEach(function(cell) {
  //     cell.element.style.height = '';
  //   });
  //   var heights = slider.cells.map(function(cell) {
  //     return cell.element.offsetHeight;
  //   });
  //   var max = Math.max.apply(Math, heights);
  //   slider.cells.forEach(function(cell) {
  //     cell.element.style.height = max + 'px';
  //   });
  //   slider.viewport.style.height = max + 'px';
  // }

  // function resetSlidesHeight() {
  //   $('.page-template-home .grid3:not(.flickity-enabled) .grid3_i, .page-template-home .grid4:not(.flickity-enabled) .grid4_i').each(function(index, el) {
  //     $(el).removeAttr('style').removeAttr('aria-hidden');
  //   });
  // }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Filtres ouverture
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  $main
    .find(".filters_triggerBtn[aria-controls]")
    .on("click", function (event) {
      event.preventDefault();
      let $el = $(this);
      let $target = $main.find("#" + $el.attr("aria-controls"));
      if ($el.hasClass("is-active")) {
        $el.attr("aria-expanded", "false").removeClass("is-active");
        $target.attr("aria-hidden", "true");
      } else {
        $main
          .find(".filters_triggerBtn")
          .attr("aria-expanded", "false")
          .removeClass("is-active");
        $main.find(".filters_tab").attr("aria-hidden", "true");
        $el.attr("aria-expanded", "true").addClass("is-active");
        $target.removeAttr("aria-hidden");
      }
    });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Formulaires
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  $main
    .find(".form[novalidate]")
    .find(".form_p input, .form_p textarea, .form_p select")
    .on("focus", function () {
      $(this)
        .closest(".form_p")
        .removeClass("is-error")
        .find(".form_error")
        .remove();
    })
    .on("blur", function () {
      form_check_validity_input(this);
    });

  function form_check_validity_input(input) {
    $(input)
      .closest(".form_p")
      .removeClass("is-error")
      .find(".form_error")
      .remove();

    if (input.type == "file") {
      if (
        input.files &&
        input.files.length &&
        input.files[0].size > 10 * 1024 * 1024
      ) {
        input.setCustomValidity("tooBig");
      } else {
        input.setCustomValidity("");
      }
    }

    if ($(input).is(":visible") && !input.validity.valid) {
      $(input).closest(".form_p").addClass("is-error");
      if (input.validity.valueMissing) {
        $(input)
          .closest(".form_p")
          .append(
            '<span class="form_error">' + str.field_invalid_required + "</span>"
          );
      } else if (input.type == "email" && input.validity.typeMismatch) {
        $(input)
          .closest(".form_p")
          .append(
            '<span class="form_error">' + str.field_invalid_email + "</span>"
          );
      } else if (input.type == "url" && input.validity.typeMismatch) {
        $(input)
          .closest(".form_p")
          .append(
            '<span class="form_error">' + str.field_invalid_url + "</span>"
          );
      } else if (
        input.type == "number" &&
        (input.validity.rangeOverflow || input.validity.rangeUnderflow)
      ) {
        $(input)
          .closest(".form_p")
          .append(
            '<span class="form_error">' +
              str.field_invalid_number_out
                .replace("%1$s", $(input).attr("min"))
                .replace("%2$s", $(input).attr("max")) +
              "</span>"
          );
      } else if (input.type == "number") {
        $(input)
          .closest(".form_p")
          .addClass("has-content")
          .append(
            '<span class="form_error">' + str.field_invalid_number + "</span>"
          );
      } else if (input.type == "file") {
        $(input)
          .closest(".form_p")
          .append(
            '<span class="form_error">' + str.field_max_file_size + "</span>"
          );
      }
      return false;
    }
    return true;
  }

  $main.find(".form[novalidate]").on("submit", function (event) {
    var noValid = false;
    $(this)
      .find(".form_p input, .form_p textarea, .form_p select")
      .each(function (index, input) {
        var inputValid = form_check_validity_input(input);
        noValid = noValid || !inputValid;
      });
    if (noValid) {
      event.preventDefault();
      scrollToEl($(this).find(".form_p.is-error").first());
    }
  });

  $main
    .find("[data-form-if-name][data-form-if-value]")
    .each(function (index, el) {
      var $el = $(el);
      var $controllers = $el
        .closest("form")
        .find('[name="' + $el.attr("data-form-if-name") + '"]');
      var conditions = $el.attr("data-form-if-value");
      if (!$controllers.length || !conditions) return;
      $controllers
        .on("change", function () {
          var noValid = $(this).val() !== conditions;
          if (noValid) {
            $el
              .hide()
              .find("input,select,textarea")
              .attr("disabled", "disabled");
            $el.removeClass("is-error").find(".form_error").remove();
          } else {
            $el.show().find("input,select,textarea").removeAttr("disabled");
          }
        })
        .filter(
          'input:not([type="radio"]),textarea,select,input[type="radio"]:checked'
        )
        .trigger("change");
    });

  function update_file_input_txt(input) {
    if (input.files && input.files.length && input.files[0].name) {
      $(input)
        .closest(".fileInput")
        .find(".fileInput_txt")
        .text(input.files[0].name);
    } else {
      $(input).closest(".fileInput").find(".fileInput_txt").text("");
    }
  }
  $main
    .find('.fileInput input[type="file"]')
    .on("change", function (event) {
      update_file_input_txt(this);
      form_check_validity_input(this);
    })
    .each(function () {
      update_file_input_txt(this);
    });

  var $first_error = $main.find(".form_field.is-error:first");
  if ($first_error.length > 0) {
    scrollToEl($first_error);
  }

  // [data-form-repeater] = button pour dupliquer
  $main.find(".form [data-form-repeater]").each(function (index, el) {
    var $el = $(el);
    var repeater = $el.attr("data-form-repeater");
    var $parent = $el.closest("p");
    var $form = $el.closest("form");
    var $target = $form.find('[data-group-name="' + repeater + '"]');
    $target.prepend(
      '<button class="btn btn-s c-1 form_group_delete">' +
        str.group_delete +
        "</button>"
    );
    if ($target.length > 1) {
      $target.find(".form_group_delete").show();
    }
    $form.on("click", ".form_group_delete", function (event) {
      event.preventDefault();
      var $form_groups = $form.find('[data-group-name="' + repeater + '"]');
      if ($form_groups.length < 2) {
        return;
      } else if ($form_groups.length < 3) {
        $form_groups.find(".form_group_delete").hide();
      }
      var $form_group = $(this).closest(".form_group");
      $form_group.slideUp(250, function () {
        $form_group.remove();
      });
    });
    var $clone = $target.first().clone();
    var cloneHTML = "";
    var cloneIdx = 1;
    $clone.removeAttr("style");
    $clone.find("input,select,textarea").each(function (idx, input) {
      input.id = input.id + "_%%idx%%";
      $(input)
        .filter("input,textarea")
        .not(":radio")
        .not(":checkbox")
        .removeAttr("value");
      $(input).filter("input").removeAttr("checked");
      $(input).find("option").removeAttr("selected");
    });
    $clone.find(".form_error").remove();
    $clone.find(".form_field.is-error").removeClass("is-error");
    $clone.find("label").each(function (idx, label) {
      $(label).attr("for", $(label).attr("for") + "_%%idx%%");
    });
    cloneHTML = $clone.get(0).outerHTML;
    $el.on("click", function (event) {
      event.preventDefault();
      $parent.before(cloneHTML.replaceAll("%%idx%%", cloneIdx));
      $form.find();
      $form
        .find('[data-group-name="' + repeater + '"] .form_group_delete')
        .show();
      cloneIdx++;
    });
  });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Keys event
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  $html.on("keydown", function (event) {
    if (event.which == 27) {
      // menu_mobile_close();
      // closeSubMenu(true);
      // modale_close();
    }
  });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //On resize
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  $window.on("resize", function (event) {
    update_dimensions();
    $window.trigger("scroll");
  });

  // Avec debounce
  var onResizeDebounce = debounce(function () {
    setCssVarVH();
    // resetSlidesHeight();
    // grid_init();
  }, 300);
  $window.on("resize", onResizeDebounce);

  $window.trigger("resize");

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Media queries
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // var mediaQuery = w.matchMedia('(min-width: 768px)');
  // function mediaQueryCheck(e) {
  //   if (e.matches) {
  //     console.log('Media Query Matched!');
  //   }
  // }
  // mediaQuery.addListener(mediaQueryCheck);
  // mediaQueryCheck(mediaQuery);

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //On scroll
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var ticking = false;
  $window.on("scroll", function (event) {
    update_scroll();
    requestTick();
  });

  function requestTick() {
    if (!ticking) {
      ticking = true;
      w.requestAnimationFrame(trigger_scroll);
    }
  }

  function trigger_scroll() {
    ticking = false;
    scroll_classes_header();
    sticky_update_all();
    page_nav_update();
    // $window.trigger('resize.adp'); //datepicker
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Formulaire adhésion — champs conditionnels selon le type de structure
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var $typesSelect = $("#form_field_types");
  if ($typesSelect.length) {
    function updateConditionalFields() {
      var selectedText = $typesSelect.find("option:selected").text().toLowerCase();
      $("[data-conditional-field='types']").each(function () {
        var values = ($(this).data("conditional-values") || "").toLowerCase().split("|");
        var matches = values.some(function (v) {
          return v && selectedText.indexOf(v) !== -1;
        });
        var $input = $(this).find("input, textarea, select");
        if (matches) {
          $(this).show();
          $input.attr("required", true);
        } else {
          $(this).hide();
          $input.removeAttr("required");
        }
      });
    }
    $typesSelect.on("change", updateConditionalFields);
    updateConditionalFields();
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Chargement menu utilisateur
  //> pas utile, quand l’utilisateur est connecté, le cache n’est pas utilisé
  //> à moins de le forcer, voir https://fr.docs.wp-rocket.me/article/333-cache-utilisateurs-connectes#meme-cache-pour-tous-les-utilisateurs
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // $.ajax({
  //     url: url.ajax,
  //     type: 'POST',
  //     dataType: 'json',
  //     data: {action: 'get_user_menu'}
  //   })
  //   .done(function(data) {
  //     if ( data ) {
  //       $header.find('.nav_i-visitor');
  //       $header.find('.nav_wrapper').append(data);
  //     }
  //   })
  //   .fail(function() {
  //   })
  //   .always(function() {
  //   });
})(jQuery);
